// src/components/dashboard/BillingEstimateCard.js
// Dashboard card — projected next invoice with band breakdown.
// Visibility gated by `set:bill:view` via src/config/dashboardCards.js.
//
// The estimate uses useSubscription's `billingEstimate`, computed from the
// server-precomputed running cycle max = max(cycleSnapshotMax, liveCount) (H1b) —
// never the raw live count alone. {total, base, overage, breakdown} are in pesos.

import { useSubscription } from "../../hooks/useSubscription";
import { INCLUDED } from "../../config/plans";
import { formatPeso as peso } from "../../utils/currency";

export const BillingEstimateCard = ({ navigate, company }) => {
  const { billingEstimate, runningCycleMax } = useSubscription();
  const { total, base, breakdown } = billingEstimate;

  return (
    <div className="dashboard-card">
      <div className="dashboard-card__header">
        <span className="dashboard-card__title">Billing estimate</span>
      </div>
      <div className="workforce__hero">
        <div className="workforce__count" style={{ fontSize: "1.9rem" }}>{peso(total)}</div>
        <div className="workforce__label">Projected next invoice</div>
      </div>

      <div style={{ marginTop: 12, fontSize: "0.85rem", color: "var(--ui-text-secondary)", lineHeight: 1.7 }}>
        <div>
          {peso(base)} base <span style={{ color: "var(--ui-text-faint)" }}>(covers 0–{INCLUDED})</span>
        </div>
        {breakdown.map((b) => (
          <div key={`${b.from}-${b.to ?? "inf"}`}>
            + {b.count} × {peso(b.rate)}{" "}
            <span style={{ color: "var(--ui-text-faint)" }}>
              (emp {b.from}{b.to == null ? "+" : `–${b.to}`})
            </span>{" "}
            = {peso(b.amount)}
          </div>
        ))}
        <div style={{ marginTop: 6, fontWeight: 700, color: "var(--ui-text)" }}>= {peso(total)} projected</div>
      </div>

      <div style={{ marginTop: 8, fontSize: "0.75rem", color: "var(--ui-text-faint)", lineHeight: 1.5 }}>
        Based on {runningCycleMax} employee{runningCycleMax === 1 ? "" : "s"} (cycle max). Final bill may differ if
        headcount rises before the cycle closes.
      </div>

      <div className="dashboard-card__footer">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/company/${company.slug}/settings/subscriptions`);
          }}
          className="dashboard-card__link"
        >
          Manage billing →
        </a>
      </div>
    </div>
  );
};
